import { MessageContent } from "./MessageContent";
import { getDate, getSide } from "./SignalMessagePageResponse";

export interface EditorialMessageContent extends MessageContent {
  title: string;
  imageUrl: string;
  description: string;
  link: string;
  postLink: string;
  signalValue: string;
  eventTitle: string;
  authorId?: string;
  authorName?: string;
  mediaLink: string;
  category: string;
  tags: any[];
  market: string;
  relatedPostContent: any;
  relatedWebinarContent: any;
  relatedRecordingContent: any;
  relatedCalendarEventContent: any;
  relatedSignalContent: any;
}

export function getPostUrl(response: EditorialMessageContent): string {
  if (response.relatedPostContent) {
    return response.relatedPostContent.PostUrl;
  } else if (response.relatedWebinarContent) {
    return response.relatedWebinarContent.EventPostUrl;
  } else if (response.relatedRecordingContent) {
    return response.relatedRecordingContent.LiveVideoUrl
  }
}

export function getEventName(response: EditorialMessageContent): string {
  if (response.relatedCalendarEventContent) 
    return response.relatedCalendarEventContent.name;
}

export function getSignalValue(response: EditorialMessageContent): string {
  if (response.relatedSignalContent)
    return `${response.relatedSignalContent.PositionMaintenanceId} | ${response.relatedSignalContent.Asset} | ${getDate(response.relatedSignalContent.OpenUtc)} | ${getSide(response.relatedSignalContent.SideType)}`;
  else
    return "";
}



// WEBPACK FOOTER //
// ./src/app/tradingstudio/models/EditorialMessageContent.ts